module.exports = __webpack_public_path__ + "media/images/edion/zh/top-537a48367476ecc1b6163d0b8d408480.png";